/**
 * Legacy re-export shim — branding logic now lives in @packages/auth.
 * This file exists so existing imports from '@/context/brandingContext' continue to work.
 *
 * New code should import from '@packages/auth' directly.
 */
import React from 'react';
import {
  BrandingProvider as SharedBrandingProvider,
  useBranding,
} from '@packages/auth';
import type { BrandingConfig, BrandingContextValue } from '@packages/auth';
import Spinners from '../components/spinner';

export type { BrandingConfig, BrandingContextValue };
export { useBranding };

const FALLBACK_TITLE = process.env.REACT_APP_SITE_TITLE ?? 'Wealthlane Customer';
const API_BASE_URL = process.env.REACT_APP_WEALTHLANE_API_ENDPOINT ?? '';

export const BrandingProvider = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <SharedBrandingProvider
    enabled={true}
    apiBaseUrl={API_BASE_URL}
    fallbackTitle={FALLBACK_TITLE}
    loadingElement={<Spinners containerClassName='h-screen' />}>
    {children}
  </SharedBrandingProvider>
);
